export default __webpack_public_path__ + "static/SevenSegment-3ee4f8118d9db6b6145675042144029d.ttf";